import { FormEvent, useState } from 'react';

import { IconArrowLeft } from '@tabler/icons-react';

import { Link, createFileRoute } from '@tanstack/react-router';

import { Anchor, Button, Container, Group, Paper, Stack, Text, TextInput, Title } from '@optiro/ui';

import { useResetPasswordRequest } from '@/hooks/useResetPasswordRequest';

export const Route = createFileRoute('/experiences/forgot-password')({
  component: RouteComponent,
});

function RouteComponent() {
  const [email, setEmail] = useState('');
  const mutation = useResetPasswordRequest();

  const handleResetPassword = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    mutation.mutate(email);
  };

  if (mutation.isSuccess) {
    return (
      <Container size="xs" py="xl">
        <Paper p="xl" radius="md" withBorder shadow="sm" bg="white">
          <Stack gap="md">
            <Title order={2} ta="center" fw={500}>
              Email sendt
            </Title>

            <Text size="sm" c="dimmed" ta="center">
              Vi har sendt dig en email med et link til at nulstille din kode. Tjek venligst din
              indbakke og spamfolder.
            </Text>

            <Link to="/experiences/login" search={undefined}>
              <Button fullWidth size="lg" style={{ backgroundColor: '#3c735b' }}>
                Tilbage til login
              </Button>
            </Link>
          </Stack>
        </Paper>
      </Container>
    );
  }

  return (
    <Container size="xs" py="xl">
      <Paper p="xl" radius="md" withBorder shadow="sm" bg="white">
        <form onSubmit={handleResetPassword}>
          <Stack gap="md">
            {/* Back button */}
            <Link to="/experiences/login" search={undefined}>
              <Anchor component="button" type="button" size="sm">
                <Group gap={4} align="center">
                  <IconArrowLeft size={16} />
                  <Text size="sm">Tilbage til login</Text>
                </Group>
              </Anchor>
            </Link>

            {/* Title */}
            <Title order={2} ta="center" fw={500}>
              Glemt kode
            </Title>

            <Text size="sm" c="dimmed" ta="center">
              Indtast din email, så sender vi dig et link til at nulstille din kode
            </Text>

            <TextInput
              label="Email"
              required
              type="email"
              size="md"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              placeholder="navn@din-virksomhed.dk"
            />

            <Button
              type="submit"
              size="lg"
              fullWidth
              loading={mutation.isPending}
              style={{ backgroundColor: '#3c735b' }}
            >
              Send email
            </Button>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
